package com.eladfinish.bible.contest.screens.openQuestions

// Markers used in the open-questions spreadsheets.

const val TABLE_OF_CONTENT = "תוכן עניינים"
const val STOP_HERE_LABEL = "*STOP HERE*"
const val DOUBLE_EXCLAMATION_MARKS = "!!" // !! - סימון המציין שהשאלות תופענה עם תשובות גלויות

/** What the sheets hold as the answer of a question nobody has answered yet. */
const val NO_ANSWER_YET = "טרם הוזנה תשובה לשאלה זו"

fun String.noPrecedingSymbols(): String = this.removePrefix(DOUBLE_EXCLAMATION_MARKS).trim()

// Topics whose questions aren't in their own sheet but behind links (see OpenQuestionsStore's
// SpecialTopicType). Matched with contains(): topic names may carry a number prefix or a "*".
const val SPECIAL_TOPIC_NUMBERS_BY_BOOKS = "מספרים לפי ספרים"
const val SPECIAL_TOPIC_EDUCATION_MINISTRY = "שאלות לפי ספרים - משרד החינוך"

fun isSpecialTopic(topicName: String): Boolean =
    topicName.contains(SPECIAL_TOPIC_NUMBERS_BY_BOOKS) || topicName.contains(SPECIAL_TOPIC_EDUCATION_MINISTRY)
